<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="修改交期"
      width="500px"
      append-to-body
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="orderDetail"
        class="form"
        label-width="110px"
        style="height: 200px;">
      <el-row>
        <el-col :span="24">
          <el-form-item label="最终交期">
            <el-date-picker
                v-model="orderDetail.confirmDeliveryDate"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="请选择"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="描述">
            <el-input
                v-model="orderDetail.approveNote"
                type="textarea"
                :rows="8"
                placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      contentLoading: false,
      disabled: "",
      orderDetail: {
        pkid: 0,
        confirmDeliveryDate: "",
        approveNote: "",
      },
    };
  },

  methods: {
    open(row) {
      this.dialogVisible = true;
      if (row) {
        this.orderDetail = row;
      }
    },
    inputHandle(row, index) {
      this.$set(this.model.detailVOS, index, row);
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
              .post("basic", "sd/so/ma/updateDelivery", this.orderDetail)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 8px;
  padding-bottom: 5px;
}
</style>
